export const DELAYED_REVIEW_STORAGE_KEY = "delayed-workplace-review.pending";

/**
 * Initial delay in milliseconds before triggering the review prompt.
 * Gives time for the app to fully load and user to land on a page.
 */
export const INITIAL_TRIGGER_DELAY_MS = 1000;
